import { render, staticRenderFns } from "./PackageEditionRadioButton.vue?vue&type=template&id=5c8e56f6&scoped=true"
import script from "./PackageEditionRadioButton.vue?vue&type=script&lang=js"
export * from "./PackageEditionRadioButton.vue?vue&type=script&lang=js"
import style0 from "./PackageEditionRadioButton.vue?vue&type=style&index=0&id=5c8e56f6&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8e56f6",
  null
  
)

export default component.exports